<template>
  <div class="section-abstract mb-1">
    <v-row class="ma-0 abstract-row" @click="openSection('SectionSalarieInformationsExtend', 'salarie', false)">
      <v-col>
        <div class="section-abstract-title">Informations complémentaires</div>
        <div class="section-abstract-grid" style="display:grid; grid-template-columns: repeat(2, minmax(0, 1fr)); column-gap: 16px; row-gap: 0; align-items: start;">
          <div class="section-abstract-cell" style="grid-row: 1 / span 1; grid-column: 1 / span 1;">
            <div class="section-abstract-label pt-2">Nom d'artiste</div>
            <div class="section-abstract-value">{{ salarie.pseudo }} <v-icon v-if="salarie.pseudo" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(salarie.pseudo, 0)">{{ copiedField === 0 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
          <div class="section-abstract-cell" style="grid-row: 1 / span 1; grid-column: 2 / span 1;">
            <div class="section-abstract-label pt-2">Numéro de congé spectacle</div>
            <div class="section-abstract-value">{{ salarie.numeroCongeSpec }} <v-icon v-if="salarie.numeroCongeSpec" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(salarie.numeroCongeSpec, 1)">{{ copiedField === 1 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
          <div class="section-abstract-cell" style="grid-row: 2 / span 1; grid-column: 1 / span 1;">
            <div class="section-abstract-label pt-2">Statut handicapé</div>
            <div class="section-abstract-value">{{ salarie.statutHandicapLabel }} <v-icon v-if="salarie.statutHandicapLabel" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(salarie.statutHandicapLabel, 2)">{{ copiedField === 2 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
          <div class="section-abstract-cell" style="grid-row: 2 / span 1; grid-column: 2 / span 1;">
            <div class="section-abstract-label pt-2">DFS</div>
            <div class="section-abstract-value">{{ salarie.abattementLabel }} <v-icon v-if="salarie.abattementLabel" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(salarie.abattementLabel, 3)">{{ copiedField === 3 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
        </div>
      </v-col>
      <v-col cols="1" class="align-content-center align-items-center">
        <v-icon class="chevron-right">
          fas fa-chevron-right
        </v-icon>
      </v-col>
    </v-row>
    <v-row class="ma-0 abstract-row" @click="openSection('SectionSalarieFiscaliteExtend', 'salarie', false)">
      <v-col>
        <div class="section-abstract-title"></div>
        <div class="section-abstract-display">Fiscalit&#233;</div>
        <div class="section-abstract-grid" style="display:grid; grid-template-columns: repeat(1, minmax(0, 1fr)); column-gap: 16px; row-gap: 0; align-items: start;">
          <div class="section-abstract-cell" style="grid-row: 1 / span 1; grid-column: 1 / span 1;">
            <div class="section-abstract-value">{{ salarie.fiscaliteLabel }} <v-icon v-if="salarie.fiscaliteLabel" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(salarie.fiscaliteLabel, 4)">{{ copiedField === 4 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
        </div>
      </v-col>
      <v-col cols="1" class="align-content-center align-items-center">
        <v-icon class="chevron-right">
          fas fa-chevron-right
        </v-icon>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
  import {defineAsyncComponent, defineComponent, markRaw, type PropType} from "vue";
  import CrudSalarie from '@/generated/cruds/CrudSalarie';
  // eslint-disable-next-line
  import { GenControl, GenSection, RessourceGenControl, RessourceGenSection } from '@/generated/ressources/generatedRessources';
  import { FwkButtons, RessourceFwkButton, RessourceFwkSection, FwkSections } from '@/ressources/globalRessources';
  import {Fiches, Modules, Sections} from '@/generated/classes/AppSchema';
  import Button, { ButtonCallback } from '@/framework/base/classes/Button';
  import Owner from '@/extend/classes/Owner';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  import Route from "@/generated/classes/Route.ts";
  import Section from '@/framework/base/classes/Section';
  import {getSection} from "@/framework/base/helpers/ComponentFinder.ts";

  export default defineComponent({
    extends:  CrudSalarie,
    components: {},
    props: {
      hideTitle: {
        type: Boolean,
      },
    },

    data() {
      return {
        sectionName: Sections.SALARIE_INFO_COMPLEMENTAIRES_ABSTRACT,
        displayMap: new Map<string, Boolean>,
        readOnlyMap: new Map<string, Boolean>,
        requiredMap: new Map<string, Boolean>,
        copiedField: null as number | null,
      }
    },

    computed: {
      saveLabel () { 
        return RessourceFwkButton(FwkButtons.ENREGISTRER).label;
      },

      errorTxt () { 
        return RessourceFwkSection(FwkSections.ERROR_TEXT).label;
      },


      ressource () { return RessourceGenSection(GenSection.SALARIE_INFO_COMPLEMENTAIRES_ABSTRACT); },

    },
    methods: {
      getRequiredAttributs(): string[] {
        const res: string[] = [];
        if (this.requiredAttributs) {
          this.requiredAttributs.forEach((attrib) => {
            const value = attrib.split(".");
            if (value[0] == this.sectionName) {
              res.push(value[1])
            }
          })
        }
        return res;
      },

      openSection(componentName: string, objType: string, isList = false): void {
        const route = new Route();
        const section  = new Section();
        const loader = getSection(componentName);
        let component = null;
        if (loader) {
          component = markRaw(defineAsyncComponent(loader as any));
        }
        if (isList) {
          route.module = Modules.SALARIE;
          route.fiche = Fiches.CONTAINER;
          route.ficheHeader = this.headerTitle();
          if (component) {
            section.component = component;
          }
          section.propType = objType;
          section.propData = this.salarie;
          route.data = section;
        }
        this.$emit('openSection', component, route, isList);
      },

      headerTitle(): string {
        return ""
      },

      requiredMissing(requiredAttributs: string[], value: string): boolean {
        return requiredAttributs.length > 0 && requiredAttributs.includes(value);
      },

      readOnly (value: string): boolean {
        let res = false;
        if (!this.editSalarie.canUpdate) {
          return true;
        }
        if (this.readOnlyMap.size == 0) {
        }
        const readOnly = this.readOnlyMap.get(value);
        if (readOnly != undefined) {
          res = readOnly;
        }
        return res;
      },

      isDisplayed (value: string): boolean {
        let res = true;
        if (this.displayMap.size == 0) {
        const requiredAttributs = this.getRequiredAttributs();
        }
        const display = this.displayMap.get(value);
        if (display != undefined) {
          res = display;
        }
        return res;
      },

      isRequired (value: string): boolean {
        let res = true;
        const requiredAttributs = this.getRequiredAttributs();
        if (this.requiredMap.size == 0) {
        }
        const required = this.requiredMap.get(value);
        if (required != undefined) {
          res = required;
        }
        return res;
      },

      picto (): string {
        return 'SectionPictoAbstract' 
      },

      sectionSave (): void {
        return this.save();
      },
      copyText(text: string, fieldIndex: number): void {
        const textToCopy = text.trim();
        navigator.clipboard.writeText(textToCopy).then(() => {
          this.copiedField = fieldIndex;
          setTimeout(() => this.copiedField = null, 1500);
        }).catch((err) => {
          console.error('Failed to copy:', err);
        });
      }
    }
  })
</script>
